// =========================================================
// 📁 RetraitCadeaux.js
// Page centrale de conversion Coins <-> Euros
// =========================================================

// =======================
// IMPORTS REACT
// =======================
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// =======================
// API & STYLES
// =======================
import API from "../../axiosInstance";
import "../../styles/Retrait.css";

// =========================================================
// COMPONENT
// =========================================================
export default function RetraitCadeaux() {
  // -------------------------------------------------------
  // 🔀 Navigation React Router
  // -------------------------------------------------------
  // Sert à rediriger l’utilisateur vers :
  // - confirmation conversion coins → euros
  // - retrait euros
  // - achat de coins
  const navigate = useNavigate();

  // -------------------------------------------------------
  // 📊 STATES – soldes réels (BDD)
  // -------------------------------------------------------
  const [coins, setCoins] = useState(0); // Solde coins réel
  const [euros, setEuros] = useState(0); // Solde euros réel

  const [rates, setRates] = useState({
    euro_to_coin: 0, // ex: 1€ = 100 coins
    coin_to_euro: 0, // ex: 100 coins = 1€
  });

  // -------------------------------------------------------
  // ⏳ STATES – chargement & erreurs
  // -------------------------------------------------------
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =======================================================
  // 🔌 CHARGEMENT DES DONNÉES DEPUIS LE BACKEND
  // =======================================================
  useEffect(() => {
    async function fetchStatus() {
      try {
        const res = await API.get("/coins/conversion/status");

        setCoins(Number(res.data.coins));
        setEuros(Number(res.data.euros));

        setRates({
          euro_to_coin: Number(res.data.rates.euro_to_coin),
          coin_to_euro: Number(res.data.rates.coin_to_euro),
        });
      } catch (err) {
        console.error("❌ Erreur chargement conversion:", err);
        setError("Impossible de charger vos soldes.");
      } finally {
        setLoading(false);
      }
    }

    fetchStatus();
  }, []);

  // =======================================================
  // ⏳ ÉTAT : CHARGEMENT
  // =======================================================
  if (loading) {
    return (
      <div className="retrait-page">
        <div className="retrait-shell">
          <p className="retrait-subtitle">Chargement des soldes…</p>
        </div>
      </div>
    );
  }

  // =======================================================
  // ❌ ÉTAT : ERREUR
  // =======================================================
  if (error) {
    return (
      <div className="retrait-page">
        <div className="retrait-shell">
          <p className="retrait-subtitle">{error}</p>
          <button
            className="retrait-back"
            onClick={() => navigate("/retrait")}
          >
            ← Retour
          </button>
        </div>
      </div>
    );
  }

  // =======================================================
  // ✅ AFFICHAGE PRINCIPAL
  // =======================================================
  return (
    <div className="retrait-page">
      <div className="retrait-shell">

        {/* =================================================
            HEADER
        ================================================= */}
        <div className="retrait-header">
          <div>
            <h2 className="retrait-title">🎁 Conversion en cadeaux</h2>
            <p className="retrait-subtitle">
              Gérez vos échanges entre coins et euros.
            </p>
          </div>

          <button
            className="retrait-back"
            onClick={() => navigate("/retrait")}
          >
            ← Retour
          </button>
        </div>

        {/* =================================================
            SOLDES ACTUELS
        ================================================= */}
        <div className="retrait-panel" style={{ marginBottom: 18 }}>
          <div className="retrait-grid">

            {/* 💰 SOLDE COINS */}
            <div
              className="retrait-card retrait-clickable"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/retrait/coins/confirmation")}
            >
              <h3 className="retrait-card-title">💰 Solde coins</h3>
              <p className="retrait-card-desc">
                {coins.toLocaleString()} coins disponibles
              </p>
              <p className="retrait-card-desc" style={{ opacity: 0.7 }}>
                Cliquer pour convertir en euros
              </p>
            </div>

            {/* 💶 SOLDE EUROS */}
            <div
              className="retrait-card retrait-clickable"
              style={{ cursor: "pointer" }} onClick={() => navigate("/retrait/euros/confirmation")}
            >
              <h3 className="retrait-card-title">💶 Solde euros</h3>
              <p className="retrait-card-desc">
                {euros.toFixed(2)} € disponibles
              </p>
              <p className="retrait-card-desc" style={{ opacity: 0.7 }}>
                Cliquer pour retirer votre argent
              </p>
            </div>

          </div>
        </div>

        {/* =================================================
            TAUX & NAVIGATION RAPIDE
        ================================================= */}
        <div className="retrait-panel">
          <div className="retrait-grid">

            {/* 🔄 EUROS → COINS */}
            <div
              className="retrait-card euros retrait-clickable"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/packs")}
            >
              <h3 className="retrait-card-title">🔄 Euros → Coins</h3>
              <p className="retrait-card-desc">
                1 € = {rates.euro_to_coin.toLocaleString()} coins
              </p>
              <p className="retrait-card-desc">
                Acheter des coins ou des packs
              </p>
            </div>

            {/* 💶 COINS → EUROS */}
            <div
              className="retrait-card cadeaux retrait-clickable"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/retrait/coins/confirmation")}
            >
              <h3 className="retrait-card-title">💶 Coins → Euros</h3>
              <p className="retrait-card-desc">
                {rates.coin_to_euro.toLocaleString()} coins = 1 €
              </p>
              <p className="retrait-card-desc">
                Convertir vos gains en argent réel
              </p>
            </div>

          </div>
        </div>

        {/* =================================================
            INFORMATION LÉGALE
        ================================================= */}
        <p className="retrait-subtitle" style={{ marginTop: 16 }}>
          ⚠️ Les taux sont définis par EVO LIVE.  
          Toute conversion est tracée et irréversible.
        </p>

      </div>
    </div>
  );
}
